export default "__VITE_ASSET__BWFVpsBN__"